import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'
import * as Helpers from 'helpers'


export class NavAnchor extends React.PureComponent<NavAnchor.Props, NavAnchor.State> {
  public static sectionId = 'anchor';

  public render(): JSX.Element {
    const { settings } = this.props.section
    const { title, label } = settings
    return (
      <section className={'dynamic-nav-anchor'}>
        <div className={'w-full md:w-5/6 mx-auto'} id={Helpers.handleize(label)}>
          <div className={'w-full md:w-4/5 px-1-6 md:px-0-4 mx-auto mb-1-6'}>
            <Snippets.Heading
              size={'h3'}
              tag={'h2'}
              className={'text-left'}
            >
              {title}
            </Snippets.Heading>
          </div>
        </div>
      </section>
    )
  }
}

export namespace NavAnchor {
  export interface Options extends ShopifyNext.Section<{
    title: string;
    label: string;
  }> { }
  export interface Props extends GlobalProps {
    section: NavAnchor.Options;
  }
  export interface State { }
}
